export const IN_APP_CARD_CHANGE_OPEN_STATE = 'IN_APP_CARD_CHANGE_OPEN_STATE'
